module.exports = __webpack_public_path__ + "img/discover-square.2a345327.svg";